module.exports = __webpack_public_path__ + "fonts/Inter-700-greek-ext66.af80f40.woff2";